const LEGACY_ROUTE_CHANGE = "labstream-legacy-route-change";
const VERSION_MISMATCH = "labstream-version-mismatch";
const VERSION_DISMISSAL_PREFIX = "labstream-version-dismissed:";

function isEmbedded() {
  return (
    typeof window !== "undefined" &&
    window.__LABSTREAM_EMBEDDED__ === true &&
    window.parent !== window
  );
}

function getInitialEmbeddedRoute() {
  if (!isEmbedded()) return null;
  return new URLSearchParams(window.location.search).get("route") || "/";
}

function postToHost(type, path) {
  if (!isEmbedded() || !window.parent || window.parent === window) return;
  window.parent.postMessage({ type, path }, window.location.origin);
}

function notifyLegacyRouteChange(path) {
  postToHost(LEGACY_ROUTE_CHANGE, path);
}

function isVersionDismissed(version) {
  return Boolean(version && window.sessionStorage.getItem(`${VERSION_DISMISSAL_PREFIX}${version}`));
}

function notifyVersionMismatch(version) {
  if (isVersionDismissed(version)) return;
  if (isEmbedded()) {
    window.parent.postMessage({ type: VERSION_MISMATCH, version }, window.location.origin);
    return;
  }
  window.dispatchEvent(new CustomEvent("app-version-mismatch", { detail: { version } }));
}

function dismissVersionMismatch(version) {
  if (version) window.sessionStorage.setItem(`${VERSION_DISMISSAL_PREFIX}${version}`, "1");
}

function clearVersionMismatchDismissals() {
  for (let index = window.sessionStorage.length - 1; index >= 0; index -= 1) {
    const key = window.sessionStorage.key(index);
    if (key && key.startsWith(VERSION_DISMISSAL_PREFIX)) window.sessionStorage.removeItem(key);
  }
}

function syncHostRoute(path) {
  notifyLegacyRouteChange(path);
}

function reloadHost() {
  if (isEmbedded() && window.parent && window.parent !== window) {
    window.parent.location.reload();
    return;
  }
  window.location.reload();
}

function redirectToLogin(router) {
  if (isEmbedded()) {
    notifyLegacyRouteChange("/login");
    return false;
  }
  router.push("/login");
  return true;
}

const embeddedNavigation = {
  isEmbedded,
  syncHostRoute,
  notifyLegacyRouteChange,
  notifyVersionMismatch,
  dismissVersionMismatch,
  clearVersionMismatchDismissals,
  reloadHost,
};

export default embeddedNavigation;

export {
  getInitialEmbeddedRoute,
  isEmbedded,
  notifyLegacyRouteChange,
  notifyVersionMismatch,
  dismissVersionMismatch,
  clearVersionMismatchDismissals,
  redirectToLogin,
  reloadHost,
  syncHostRoute,
};
